import React, { useMemo } from 'react';
export const TextHighlighter = ({
    contentString,
    toMatch, // string, array of string, [{toMatchText: '', highlightCustomStyle: ''}],
    typography={className: 'text_body_light'},
    highlightStyle={background: "rgba(255, 172, 18, 0.4)", textTransform: "capitalize"},
    ...props
}) => {
    let toMatches = Array.isArray(toMatch) ? toMatch : [toMatch];
    toMatches = toMatches.map((item) => {
        if (item !== null && item !== undefined) {
            if (typeof item === 'number') {
                item = item.toString();
            }
            return typeof item === 'string' ? { toMatchText: item } : item;
        }
        return null;
    }).filter(item => item !== null);
    let toMatchStr = toMatches.map((toMatch) => toMatch?.toMatchText).join(", ")
    
    const replaceContent = useMemo(() => {
        if (!toMatch || !contentString) return contentString;
        let patternStrings = toMatches.map(tm => tm.toMatchText);
        let patternRegex = new RegExp(`(${patternStrings.join('|')})`, 'gi');  
        
        let highlightedHtml = <>
            {
            contentString.split(patternRegex).map((section, index) => {            
                let matchedPattern = toMatches.filter(tm => tm.toMatchText?.toLowerCase() === section?.toLowerCase())[0]
                if(matchedPattern){
                    let highlightCustomStyle = matchedPattern.highlightCustomStyle || highlightStyle;
                    return (
                        <span key={index} style={highlightCustomStyle}>
                            {section}
                        </span>                    
                    )
                }else {
                    return section
                }
            })}
        </>
        return highlightedHtml;
    }, [contentString, highlightStyle, toMatchStr]);

    if (!contentString) return <div></div>;
    return <div className={typography.className} style={props.style}>{replaceContent}</div>;
};

export const escapeRegex = (string) => {
    return string.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
};
